import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SidebarService {
  isCollapsed = new BehaviorSubject<boolean>(true);

  toggleSidebar(value: boolean) {
    this.isCollapsed.next(value);
  }

  getSidebarState() {
    return this.isCollapsed.value;
  }
}
